import { useRef } from 'react';
import { shallowCompare } from './shallow-diff';
/**
 * Returns a stable reference to `callback` that only changes when one of the
 * provided `deps` changes. Behaves like `useCallback(callback, deps)` but lets
 * a hook accept a caller-provided dependency list, which `useCallback` cannot
 * do without tripping the `react-hooks/exhaustive-deps` static check.
 *
 * @param callback - The callback to memoize.
 * @param deps - Dependencies that, when changed, swap in the latest callback.
 * @returns The memoized callback reference.
 *
 * @example
 * const stable = useMemoizedCallback(onChange, [value]);
 */
export const useMemoizedCallback = (callback, deps) => {
    const ref = useRef({ deps, callback });
    if (ref.current.deps.length !== deps.length || shallowCompare(ref.current.deps, deps)) {
        ref.current = { deps, callback };
    }
    return ref.current.callback;
};
